export default "__VITE_ASSET__C7Uo7tBz__"